import { createTheme } from "@mui/material/styles";

export const colors = createTheme({
  palette: {
    primary: {
      main: "#07468E",
    },
    secondary: {
      main: "#6C757D",
    },
    danger: {
      main: "#f25454",
    },
    info: {
      main: "#31CDE8",
    },
    nav: {
      main: "#000922",
    },
    blue: {
      main: "#0B2D39",
    },
    white: {
      main: "#FFFFFF",
    },
    grey: {
      main: "#C7C7C7",
    },
  },
});
